/**
 *  * this create news article image swap
 *   */
import $ from 'jquery';

export  function initNewsImageSwap(){

    if($(".newsImageListItem > a").length >0){
    $(".newsImageListItem:first-child > a").addClass("selected");
        $(".newsImageListItem > a" ).on('click' ,function() {
        $(".newsImageListItem:first-child > a").removeClass("selected");
            $(".newsImageListItem > a").removeClass("selected");
            var src = $(this).attr('data-src');
            var srcOrig = $(this).attr('data-src-original');
            $(this).addClass("selected");
            $('.newsImageMain > .selectedImg').attr("src",src);
            $('.newsImageMain > .selectedImg').attr("data-fullpath",srcOrig);
        });
    }

}

